var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getHookEventElement } from '../utils/internal/getHookEventElement';
import { useEvent } from './useEvent';
import { useEventListener, } from './useEventListener';
/** Detect click outside some element */
export function useOutsideClick(ref, callback, props) {
    var callbackEvent = useEvent(callback);
    useEventListener(__assign({ ref: typeof document !== 'undefined' ? document : null, target: 'mousedown', listener: function (event) {
            var element = getHookEventElement(ref);
            if (!element) {
                return;
            }
            if (!element.contains(event === null || event === void 0 ? void 0 : event.target) && event.which === 1) {
                callbackEvent(event);
            }
        } }, props));
}
//# sourceMappingURL=useOutsideClick.js.map